module.exports = __webpack_public_path__ + "static/media/adv-img4.8cabfab1.jpg";